import { Component, OnDestroy } from '@angular/core';
import { AuthService, NotifyService, SettingsService } from '@app/services';
import { CompanySetting } from '@models/settings/company-setting.model';
import { Subscription } from 'rxjs';

@Component({
    templateUrl: './performance-index.view.html',
    styleUrls: ['./performance-index.style.scss'],
})
export class PerformanceIndexView implements OnDestroy {
    isLoading: boolean;
    settings: CompanySetting[] = [];

    resources = ['feedback', 'goal', 'review', 'survey'];
    entities = ['creator', 'subject', 'participant'];

    resourceTags = {
        feedback: 'settings.performance-notifications.feedbackHeader',
        goal: 'settings.performance-notifications.goalHeader',
        review: 'settings.performance-notifications.reviewHeader',
        survey: 'settings.performance-notifications.surveyHeader',
    };

    entityTags = {
        creator: 'settings.performance-notifications.creatorEntityLabel',
        subject: 'settings.performance-notifications.subjectEntityLabel',
        participant: 'settings.performance-notifications.participantEntityLabel',
    };

    sortedSettings = new Map<string, CompanySetting[]>();
    settingsSubscription: Subscription = this.loadData();

    constructor(
        private notify: NotifyService,
        private settingsService: SettingsService,
        private auth: AuthService
    ) {}

    ngOnDestroy(): void {
        this.settingsSubscription.unsubscribe();
    }

    changeSetting(companySetting: CompanySetting): void {
        companySetting.param('company', this.auth.company.id);
        companySetting.toggle().catch(() => {
            this.notify.error('settings.performance-notifications.settingChangeErrorMessage');
        });
    }

    private loadData(): Subscription {
        return this.settingsService.onLoading().subscribe((isLoading: boolean) => {
            if (isLoading) {
                this.isLoading = isLoading;
                return;
            }

            this.settings = this.settingsService.getByModule('PerformanceManagement');

            for (const resource of this.resources) {
                const resourceGroup = this.settings.filter(
                    (s: CompanySetting) => s.setting.name.indexOf(resource) > -1
                );

                for (const entity of this.entities) {
                    const entityGroup = resourceGroup.filter(
                        (s: CompanySetting) => s.setting.name.indexOf(entity) > -1
                    );

                    if (entityGroup.length > 0) {
                        this.sortedSettings.set(`${resource}.${entity}`, entityGroup);
                    }
                }
            }

            this.isLoading = isLoading;
        });
    }
}
